<template>
  <div class="information_message_area">
    <div class="information_message">
      <a class="message_text" :href="hrefUrl">{{ strMsg }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'information-message',
  props: {
    strMsg: { type: String, default: '' },
    hrefUrl: { type: String, default: '/'}
  },
}</script>

<style lang="scss">
.information_message_area {
  background: #FFFFFF;
  padding: 0  12px 16px 12px;
}
.information_message {
//  margin: 12px;
//  padding: 0 12px 16px 12px;
  background: #FFF1F1;
//  background: #FEF5F9;
  border: 1px solid #F2D0DF;
  box-sizing: border-box;
  border-radius: 4px;
  line-height: 13px;
  font-size: 13px;
  color: #ed1e79;
  padding: 0 8px 0 16px;
  height: 40px;
//  position: relative;
  display: flex;
  align-items: center;
  justify-items: center;
  place-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;

  .message_text {
    position: relative;
    margin: 0;
    width: 100%;
    color: #DE0000;
    text-decoration: none;
  }

  &:after {
    content: '';
    min-width: 16px;
    min-height: 16px;
    background: url(/static/img/common/arrow_right_pink.svg) no-repeat center;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/InformationMessage.vue